module.exports = __webpack_public_path__ + "static/media/4piechart.c7c026cb.png";